var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup256(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 28.125,
    height: 32,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(-1039 -255)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1039 255)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(1051 265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M50.625,48.563a2.813,2.813,0,1,0-2.812,2.813,2.816,2.816,0,0,0,2.813-2.812m-3.75,0a.938.938,0,1,1,.938.938.939.939,0,0,1-.937-.937",
    transform: "translate(-41.25 -41.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M26.652,19.824a5.613,5.613,0,0,0-6.428,0,4.1,4.1,0,0,0-.549.5L11.2,17.495a3.039,3.039,0,0,0,.052-.557A3.679,3.679,0,0,0,8.941,13.7q.26-.265.53-.533c1.639-1.639,3.5-3.5,3.652-6.493V6.625A6.611,6.611,0,0,0,11.2,1.963a6.466,6.466,0,0,0-9.281,0A6.611,6.611,0,0,0,0,6.625v.049c.156,3,2.014,4.855,3.652,6.493q.269.269.53.533a3.679,3.679,0,0,0-2.309,3.237,3.457,3.457,0,0,0,1.473,2.739,5.37,5.37,0,0,0,3.214,1.011,5.37,5.37,0,0,0,3.214-1.011,4.1,4.1,0,0,0,.55-.5L18.8,22.006a3.016,3.016,0,0,0,.1,1.492l-5.1,2.235c-.086-.076-.174-.15-.268-.221A5.37,5.37,0,0,0,10.313,24.5,5.37,5.37,0,0,0,7.1,25.511a3.282,3.282,0,0,0,0,5.477A5.37,5.37,0,0,0,10.313,32a5.37,5.37,0,0,0,3.214-1.011A3.457,3.457,0,0,0,15,28.25a3.064,3.064,0,0,0-.148-.934l5.1-2.235c.086.076.174.15.268.22a5.613,5.613,0,0,0,6.428,0,3.282,3.282,0,0,0,0-5.477M1.875,6.6A4.782,4.782,0,0,1,6.563,1.875,4.782,4.782,0,0,1,11.25,6.6c-.128,2.264-1.574,3.71-3.1,5.24-.535.535-1.081,1.081-1.583,1.674-.5-.593-1.048-1.139-1.583-1.674C3.449,10.311,2,8.865,1.875,6.6M6.563,18.813c-1.524,0-2.812-.859-2.812-1.875,0-.755.73-1.448,1.762-1.735.252.336.309.446,1.05,1.55.755-1.125.8-1.215,1.05-1.55,1.033.287,1.762.98,1.762,1.735,0,1.016-1.288,1.875-2.812,1.875m3.75,11.313c-1.524,0-2.812-.859-2.812-1.875s1.288-1.875,2.813-1.875,2.813.859,2.813,1.875-1.288,1.875-2.812,1.875m13.125-5.687c-1.524,0-2.812-.859-2.812-1.875s1.288-1.875,2.813-1.875,2.813.859,2.813,1.875-1.288,1.875-2.812,1.875",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup256);
export default __webpack_public_path__ + "static/media/Group256.0f93f802bd4bb87f3967d5f998a91f0b.svg";
export { ForwardRef as ReactComponent };